import { SaveAsButton } from './Watchlist/Buttons';
import WatchlistView from './Watchlist/WatchlistView';
import { useParams } from 'react-router';
import { usePublishedWatchlist } from 'utils/hooks';

function PublishedWatchlist() {
    const { watchlistId } = useParams();
    const { isLoading, isFetching, data } = usePublishedWatchlist(watchlistId);

    return (
        <WatchlistView
            watchlist={data}
            watchlistId={watchlistId}
            watchlistItems={data ? data.items : null}
            isLoadingWatchlists={isLoading}
            isLoadingWatchlistItems={isLoading}
            isFetchingWatchlistItems={isFetching}
            menuItems={{ duplicate: SaveAsButton }}
        />
    );
}

export default PublishedWatchlist;
